export enum Routes {
  ROOT = '/',
  HDB_RESALE = '/hdb-resale',
  PRIVATE_RESALE = '/private-resale',
  COMMERCIAL_INDUSTRIAL = '/commercial-industrial',
  OTHERS = '/others',
}

export enum HdbResaleRoutes {
  PURCHASE = '/hdb-resale-purchase',
  MSR = '/msr',
  SALES_PROCEEDS = '/sales-proceeds',
}

export enum PrivateResaleRoutes {
  PURCHASE_RESALE = '/purchase-resale',
  PURCHASE_NEW_PROJECT = '/purchase-new-project',
  TDSR = '/tdsr',
  SALES_PROCEEDS = '/sales-proceeds',
  BUYER_STAMP_DUTY = '/iras-stamp-duty',
  RENTAL_YIELD = '/rental-yield',
  preview = '/preview',
}

export enum CommercialIndustrialRoutes {
  PURCHASE_RESALE = '/purchase-resale',
  SALES_PROCEEDS = '/sales-proceeds',
  RENTAL_YIELD = '/rental-yield',
  RESALE_VS_BUC = '/resale-vs-buc',
  INVESTMENT = '/investment',
}

export enum OthersRoutes {
  MORTGAGE_LOAN = '/mortgage-loan',
  PART_SHARE_PURCHASE = '/part-share-purchase',
  RENTAL_YIELD = '/rental-yield',
  EQUITY_TERM_LOAN = '/equity-term-loan',
  PLEDGE_UNPLEDGE = '/pledge-unpledge',
  RENTAL_STAMP_DUTY = '/rental-stamp-duty',
  BUYER_STAMP_DUTY = '/iras-stamp-duty',
  MSR = '/msr',
  CPF_USAGE = '/cpf-usage',
}

export enum PreviewRoutes {
  MORTGAGE_LOAN = '/mortgage-loan/preview',
  PART_SHARE_PURCHASE = '/part-share-purchase/preview',
  EQUITY_TERM_LOAN = '/equity-term-loan/preview',
  PLEDGE_UNPLEDGE = '/pledge-unpledge/preview',
  RENTAL_STAMP_DUTY = '/rental-stamp-duty/preview',
  PURCHASE_RESALE = '/purchase-resale/preview',
  PURCHASE_NEW_PROJECT = '/purchase-new-project/preview',
  BUYER_STAMP_DUTY = '/iras-stamp-duty/preview',
  MSR = '/msr/preview',
  CPF_USAGE = '/cpf-usage/preview',
  SALES_PROCEEDS = '/sales-proceeds/preview',
  HDB_RESALE_PURCHASE = '/hdb-resale-purchase/preview',
}

export type RouteKey =
  | `${Routes}`
  | `${HdbResaleRoutes}`
  | `${PrivateResaleRoutes}`
  | `${CommercialIndustrialRoutes}`
  | `${OthersRoutes}`
  | `${PreviewRoutes}`;
